var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalkToExperts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 75,
    viewBox: "0 0 70 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-talk-experts {\n        fill: #e08a8a;\n      }\n\n      .cls-2-talk-experts {\n        fill: #fff;\n      }\n\n      .cls-3-talk-experts {\n        filter: url(#Rectangle_5001);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5001",
    x: 0,
    y: 0,
    width: 70,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5375",
    "data-name": "Group 5375",
    transform: "translate(-295 -664)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3-talk-experts",
    transform: "matrix(1, 0, 0, 1, 295, 664)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5001-2",
    "data-name": "Rectangle 5001",
    className: "cls-1-talk-experts",
    width: 52,
    height: 57,
    rx: 8,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_69",
    "data-name": "Union 69",
    className: "cls-2-talk-experts",
    d: "M21063.449,19287.039c-3.9-1.986-6.449-5.295-6.449-9.039,0-6.076,6.717-11,15-11s15,4.922,15,11-6.717,11-15,11q-.724,0-1.43-.051l-7.482,4.215Z",
    transform: "translate(-20742 -18582)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToExperts);
export default __webpack_public_path__ + "static/media/talk-to-experts.81106ffc.svg";
export { ForwardRef as ReactComponent };